<template>
    <div>
        <div class="bar"></div>
        <div class="tip">企业版的功能和权益将会不断扩充，首选推荐企业版四季度版本</div>
        <div class="background" id="backgroundId">
            <div class="backgroundText1">您的企业版套件订单已通过审核</div>
            <div class="backgroundText2">请您确认合同并完成付款</div>
            <!-- 电子合同 -->
            <div class="contract">
                <img
                src="~@/assets/newHome/合同已生成.png"
                alt=""
                class="contractIcon"
                />
                <div class="text1">
                您的订单
                <span
                    style="color: #006699; font-family: PingFang SC; font-weight: 500"
                    >{{requestName}}(编号{{requirementId}})</span
                >
                合同已生成
                </div>
                <div class="text2">
                    请您尽快下载并确认合同内容，盖章(签字)后上传扫描件。同时您需要线下邮寄纸质版合同（邮寄地址：吉林省长春市北湖科技开发区明溪路1299号长光卫星技术股份有限公司，邮编：130000，电话: 0431-86008580，收件人：马先生）。特别提醒您，在您上传合同扫描件并最终点击确认之后，合同即生效，且具备法律效力，受《合同法》保护。系统将安排数据生产任务。若您对合同内容有异议，请联系商务经理。
                </div>
                <div class="xuxian"></div>
                <div class="xuxian" style="left: 731px"></div>
                <div class="text3">请您仔细核对合同内容</div>
                <img
                    src="~@/assets/newHome/核对合同.png"
                    alt=""
                    class="checkIcon"
                />
                <div class="pdfToPic">
                    <div class="contentText1">合同编号：<span style="font-family:Arial;"></span></div>
                    <div class="contentText1" style="top: 90px;">订单编号：<span style="font-family:Arial;">{{requirementId}}</span></div>
                    <div class="contentText2">吉林一号切片影像套件产品<br>服务合同</div>
                    <div class="contentText4" style="margin-top: 410px;">购买方(甲方)：{{userClientName}}</div>
                    <div class="contentText4">销售方(乙方)：长光卫星技术股份有限公司</div>
                    <div class="contentText4">签订时间：{{confirmTime}}</div>
                    <div class="contentText4">签订地点：吉林长春</div>
                    <div class="contentText4">有效期限：{{confirmTime}} - {{endTime}}</div>
                    <!-- <div class="contentText5">鉴于本合同为甲方向乙方购买相关技术服务，并支付相应的服务报酬。为明确各自的权利和义务，根据《中华人民共和国民法典》等有关法律法规的规定，订立本合同。</div> -->
                    <div class="contentText6" style="margin-top: 100px;text-align: center;font-size: 24px;">吉林一号切片影像套件产品服务合同</div>

                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 70px;">购买方（甲方）：{{ userClientName }}</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;">销售方（乙方）：长光卫星技术股份有限公司</div>
                    <div class="contentText7" style="line-height: 35px;margin-top: 30px;">甲方经与乙方友好协商，依据《中华人民共和国民法典》等相关法律法规就乙方向甲方提供{{requestNameReal}}吉林一号切片影像套件产品服务事宜于 {{ confirmTime1 }} 在中华人民共和国吉林省长春市签订合同如下：</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 5px;">甲方所选购产品的服务截止日期为 {{ endTime1 }}，服务期内甲方享有本合同规定的权益与义务。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 30px;">1、甲方权益</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">（1）甲方可通过互联网调用乙方提供的吉林一号卫星影像API服务。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（2）甲方同时享有所购买产品有效期内最大10万平方公里的面积权限、单日最大访问300万次的调用权限和最大300次/秒的并发数权限。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（3）甲方享有乙方提供的免费工具集服务。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">2、甲方义务</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">（1）甲方需妥善保管好本单位的密钥，不得转借给其他单位或个人使用，若发现任何包括但不限于非法使用专有账号或其他有安全问题的情况，应立即告知乙方。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（2）本产品仅供甲方单位使用，不得将产品密钥转卖给其他单位或个人。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（3）由甲方保管用户名和密码不善或泄露数据库信息所带来的损失，由甲方承担。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（4）甲方使用所购买产品不得损害国家和社会公共利益，产生后果由甲方承担。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（5）甲方应知悉产品调用权限和并发数权限，超出相关权限后访问将受限。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（6）甲方承诺不通过API向乙方计算机进行任何与本产品服务无关的恶意操作。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（7）甲方如需要基于所购买产品开展商业活动，需向乙方提出书面申请，经乙方书面同意后方可进行。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">3、乙方义务</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">（1）合同生效后，乙方应保证两天内向甲方提供所购买产品服务。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（2）在合同有效期内，应保证甲方享有所购买产品的稳定服务，并定期告知甲方产品使用状况和剩余权限。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（3）若产品出现变更等情况，应及时告知甲方，并保证甲方的权益直至有效期结束。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">4、付款方式</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">合同签订之日起 7日内,甲方向乙方支付合同款100%，即人民币 {{ payChinese }}（小写：人民币 {{ payFinal }} 元）。乙方向甲方开具同等金额的正式增值税（6%）发票。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">5、验收</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">产品到服务截止日期后系统默认自动验收。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">6、知识产权</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">甲方在按照本合同约定的方式使用所购买产品（包括但不限于将合同数据用于商业服务、出版印刷、科学文献、商业杂志、宣传展示用幻灯片、透明片、图片等）时，均必须注明：版权所有及数据年份等标识。版权（Copyright）、数据年份等标识，由长光卫星技术股份有限公司提供。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">若甲方违反上述约定，应当独立承担因此引起的一切法律责任，应当赔偿乙方因此所遭受的一切损失。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">7、保密责任</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">甲方对于合同成果以及因履行本合同而知悉的乙方的商业秘密和技术秘密等信息承担保密责任，未经乙方事先书面同意，甲方不得向任何第三人披露、以任何形式使用或许可他人使用上述信息（法律或政府权力机构要求的除外）。甲方未遵守本条规定，给乙方造成损失的，甲方应当赔偿乙方因此所遭受的一切损失。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">8、违约责任</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">如果因乙方原因（不可抗力除外）延迟交付合同成果，每延迟五个工作日，按延迟交付成果金额的0.5%，乙方向甲方支付违约金。违约金总额累计不超出合同总额的5%。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">由于甲方原因，导致本合同不能完全或部分履行，甲方应当赔偿乙方因此所遭受的一切损失。损失包括乙方为甲方提供服务的单位时间内的人力费用和资产费用，数据处理系统的自然损耗费用等；乙方因调查甲方违约所支出的调查费用、律师费用、诉讼费用以及其他乙方认为必要的费用等。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">如果甲方不能按时向乙方支付应付合同款（因不可抗力原因导致的除外），每延误一日，甲方向乙方支付违约金,金额为该期付款总额的0.5%。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">9、“不可抗力”</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">“不可抗力事件”系指合同双方不能预见、不能预防、避免并克服的事件。“不可抗力事件”包括但不限于：合同成果处理系统发生故障或损坏、恶劣天气、政府禁令或法令法规、大罢工、骚乱等，地震，海啸等自然灾害。当发生不可抗力，致使乙方无法全部或部分履行其义务时，乙方不承担任何违约责任。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">10、合同的签订和终止</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">（1）本合同自双方代表签字盖章确认之日起生效。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（2）本合同有效期满后，合同即行终止。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（3）甲方在网站业务活动中违反国家有关法律和网站的规定，乙方有权立即终止本协议。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（4）本合同终止后，甲方应继续履行本合同第6条和第7条规定的相关义务。不得以任何形式许可他人使用合同成果，若甲方违反上述约定，应当赔偿乙方因此所遭受的一切损失。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">11、适用法律</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">本合同受中华人民共和国民法典管辖。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">12、其它</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 10px;">（1）本合同一式肆份，甲、乙双方各执贰份，自甲乙双方签字盖章之日起生效。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（2）如双方在本合同执行过程中发生争议，应本着平等互利的原则友好协商，如协商不成，任何一方均可向甲方所在地的人民法院提起诉讼。</div>
                    <div class="contentText7" style="line-height: 30px;margin-top: 0px;">（3）本合同未尽事宜，双方协商解决。</div>
                    <div class="contentText7" style="text-indent:0;font-weight: 600;margin-top: 20px;">13、合同签署</div>
                    <div class="contentText10">
                        <div class="contentText8" style="margin-left: 0px;margin-top: 0px;">甲方：{{ userClientName }}</div>
                        <div class="contentText9" style="margin-right: 0px;margin-top: 0px;">乙方：长光卫星技术股份有限公司</div>
                    </div>                    
                    <div class="contentText8">盖<span style="padding-left: 2em;">章：</span></div>
                    <div class="contentText9">盖<span style="padding-left: 2em;">章：</span></div>
                    <div class="contentText8">授权代表（签字）：</div>
                    <div class="contentText9">授权代表（签字）：</div>
                    <div class="contentText8">签订日期：<span style="padding-left: 4em;">年</span> <span style="padding-left: 2em;">月</span>  <span style="padding-left: 2em;">日</span></div>
                    <div class="contentText9">签订日期：<span style="padding-left: 4em;">年</span> <span style="padding-left: 2em;">月</span>  <span style="padding-left: 2em;">日</span></div>
                    <div class="contentText8">联系电话：</div>
                    <div class="contentText9">联系电话：</div>                 
                </div>
                <div class="confirmContract" @click="load()">下载合同</div>
                <div class="confirmContract11" @click="tip=1">上传扫描件</div>
            </div>
           
        </div>
        <div class="contractDialog" v-if="tip==1">
            <div class="white1">
                <img src="~@/assets/newHome/日历关闭.png" alt="" class="closeDialog" @click="tip=0"/>
                <div class="diglogText1">请上传并确认</div>
                <div class="diglogText3">再次提醒您确认：
                <br> 1. 在您点击“一键确认”之后，合同即生效且具备法律效力，受《合同法》保护。若您对合同内容有异议，请联系商务经理协助处理；<span @click="load()" style="color: #006699;cursor: pointer;text-decoration:underline;">点击下载合同</span>
                </div>
                <input
                type="file"
                class="fileUpload"
                name="file"
                id="file"
                @input="fileChange"
                />
                <img
                src="~@/assets/newHome/上传合同扫描件.png"
                alt=""
                class="paperIcon"
                v-if="!isUpload"
                />
                <div class="paperText" v-if="!isUpload">上传合同扫描件</div>
                <div class="paperText2" v-if="isUpload">{{fileName}}</div>
                <div class="paperConfirm" id="paperConfirmId" @click="confirmContract()">一键确认</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Contract",
    data(){
        return{
            requirementId:"JL1_TILE_202304240915220001",
            tip:0,
            requestName:"吉林一号切片影像套件产品服务",
            requestNameReal:"",
            userClientName:"北京航天世景信息技术有限公司",
            confirmTime:"2023.01.16",
            confirmTime1:"2023.01.16",
            endTime:"2023.04.16",
            endTime1:"2023.04.16",
            type:"2023年第一季度",
            payFinal:"148000",
            payChinese:"壹拾肆万捌仟元整",
            contractUrl:"",
            //判断纸质合同扫描件是否上传
            isUpload:false,
            fileName:"",
            file:[],
            
        }
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        
        toPageTop(){
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        },
        //获取合同信息
        getContract(){
        this.requirementId=this.$route.query.id;
        let param = new FormData();
        param.append("id", this.requirementId);
        this.axios
            .post(
                "/tilesapi/tiles/contract/queryContractByOrderId",
                param,
                {
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
                }
            )
            .then((res) => {
                console.log(res)
                let data = res.data.data
                this.userClientName=data.userClientName
                let year = data.confirmTime.substring(0,4)
                let month = data.confirmTime.substring(5,7)
                let day = data.confirmTime.substring(8,10)
                this.confirmTime = year + '.'+ month + '.' +day 
                this.confirmTime1 = year + '年'+ month + '月' +day +'日'
                this.requestNameReal=data.requestName
                this.contractUrl=data.url
                let year1 = data.endTime.substring(0,4)
                let month1 = data.endTime.substring(5,7)
                let day1 = data.endTime.substring(8,10)
                this.endTime=year1 + '.'+ month1 + '.' +day1
                this.endTime1=year1 + '年'+ month1 + '月' +day1 +'日'
                this.payFinal=data.payFinal
                this.payChinese=data.payChinese
            });
        },
        
        
        load(){
        let url =this.contractUrl
        if (this.$store.state.user.logined) {
            window.open(url)
        } else {
            window.open("/Login?returnUrl=" + "/ElectronicContract", "_blank");
        }
        },
        fileChange(){
            let fileId = document.getElementById("file");
            let files = fileId.files;
            let paperConfirmId = document.getElementById("paperConfirmId")
            if(files.length>0){
                this.isUpload=true
                this.fileName=files[0].name
                this.file=files[0]
                paperConfirmId.style.backgroundColor="#006699"
                paperConfirmId.style.cursor="pointer"
            }else{
                paperConfirmId.style.backgroundColor="#CCCCCC"
                
            }
            },
        //用户确认纸质合同
        confirmContract(){
        this.tip=0
        let formData = new FormData();
        formData.append("id", this.requirementId);
        formData.append("file", this.file);
        this.axios.post(
            "/tilesapi/tiles/contract/uploadContractFile",formData,
            {headers: {
                Authorization: "Bearer " + this.getKey(),
            },}
        ).then((res) => {
            this.tip=0
            if(res.status==200){
                this.$router.push({path: "/MyRSservices"}); 
            }else{
                alert("确认失败，请刷新页面后再次尝试！")
            }
        });
        },
     
        
    },
    mounted(){
        this.toPageTop()
        this.getContract()
    }

}
</script>

<style scoped>
.bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.tip{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #F5F5F6;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 76px;
    text-align: center;
}
.background {
  position: relative;
  width: 100%;
  height: 4900px;
  background: #fff;
}
.backgroundText1{
    position: absolute;
    top: 75px;
    left: calc(50% - 400px);
    width: 800px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.backgroundText2{
    position: absolute;
    top: 142px;
left: calc(50% - 400px);
    width: 800px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 22px;
text-align: center;
}
.whiteStatus {
  position: absolute;
  width: 100%;
  height: 160px;
  background: #ffffff;
}
.whiteContent {
  position: absolute;
  width: 1280px;
  height: 160px;
  left: calc(50% - 640px);
  top: 0px;
}
.companyIcon {
  position: absolute;
  top: 45px;
  left: 0px;
}
.status1{
position: absolute;
width: 40px;
height: 40px;
top: 45px;
left:620px;
z-index: 1;
}
.status2{
position: absolute;
width: 15px;
height: 12px;
top: 59px;
left: 633px;
z-index: 2;
}
.statusText1{
  position: absolute;
  width:100px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #3A3A3A;
line-height: 22px;
top: 96px;
left: 608px;
}
.statusText2{
  position: absolute;
  top: 118px;
  left: 749px;
  width: 86px;
height: 17px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 17px;
text-align: center;
}
.statusText3{
  position: absolute;
  width: 14px;
height: 23px;
font-size: 16px;
font-family: Arial-Black, Arial;
font-weight: 900;
color: #FFFFFF;
line-height: 23px;
top: 53px;
left: 939px;
z-index: 2;
}
.line1{
  position: absolute;
  /* width: 115px; */
top: 64px;
left: 658px;
/* z-index: 0; */
}
.contract {
  position: absolute;
  top: 160px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 4500px;
  background: #ffffff;
  border-radius: 12px;
}
.contractIcon {
  position: absolute;
  width: 78px;
  height: 78px;
  top: 100px;
  left: calc(50% - 39px);
}
.text1 {
  position: absolute;
  top: 208px;
  width: 1280px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
  text-align: center;
}
.text2 {
  position: absolute;
  top: 262px;
  left: calc(50% - 400px);
  width: 800px;
  height: 60px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #3a3a3a;
  line-height: 30px;
  text-align: center;
}
.xuxian {
  position: absolute;
  top: 467px;
  left: 160px;
  width: 389px;
  padding: 10px;
  background: linear-gradient(
    to left,
    transparent 0%,
    transparent 50%,
    #979797 50%,
    #979797 100%
  );
  background-size: 10px 1px; /* 第一个参数控制虚线的间隙（利用的是图片的放大效果一样），第二个参数控制虚线的粗细 */
  background-repeat: repeat-x;
  background-position: top; /* 控制方向：top、bottom */
}
.text3 {
  position: absolute;
  top: 460px;
  left: 549px;
  width: 182px;
  height: 16px;
  font-size: 16px;
  font-family: STFangsong;
  color: #3a3a3a;
  line-height: 16px;
  text-align: center;
}
.checkIcon{
    position: absolute;
    top: 490px;
    width: 30px;
    height: 30px;
    left: calc(50% - 15px);
}
.shadow{
    position: absolute;
    top: 920px;
    width: 990px;
    height: 306px;
    left: calc(50% - 495px);
    /* background-color: pink; */
}
.checkContract{
    position: absolute;
    top: 1250px;
    left: calc(50% - 75px);
    width: 150px;
height: 40px;
background: #006699;
border-radius: 6px;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.pdfToPic {
  position: absolute;
  top: 550px;
  width: 960px;
  height:3700px;
  left: calc(50% - 480px);
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.contentText1{
    position: absolute;
    top: 66px;
    left: 80px;
    width: 960px;
height: 17px;
font-size: 16px;
font-family: STFangsong;
color: #3A3A3A;
line-height: 16px;
text-align: left;
}
.contentText2{
    position: absolute;
    top: 200px;
    width: 960px;
height: 80px;
font-size: 40px;
font-family: STFangsong;
color: #3A3A3A;
line-height: 40px;
text-align: center;
}
.contentText3{
    margin-top: 363px;
    margin-left: 80px;
    width: 880px;
height: 20px;
font-size: 20px;
font-family: STFangsong;
color: #3A3A3A;
line-height: 20px; 
}
.contentText4{
    margin-top: 20px;
    margin-left: 80px;
    width: 880px;
height: 20px;
font-size: 22px;
font-family: STFangsong;
color: #3A3A3A;
line-height: 20px;
}
.contentText5{
    margin-top: 67px;
    margin-left: 80px;
    width:806px;
height: auto;
font-size: 20px;
font-family: STFangsong;
color: #3A3A3A;
line-height: 28px;
text-indent: 2em;
text-align:justify;
}
.contentText6{
    margin-top: 20px;
    margin-left: 80px;
    width:806px;
height: auto;
font-size: 20px;
font-family: STFangsong;
color: #3A3A3A;
font-weight: 600;
line-height: 20px;
text-indent: 2em;
}
.contentText7{
    margin-top: 20px;
    margin-left: 80px;
    width:806px;
    height: auto;
    font-size: 20px;
    font-family: STFangsong;
    color: #3A3A3A;
    line-height: 20px;
    text-indent: 2em;
    text-align:justify;
}
.contentText10{
    float: left;
    margin-top: 20px;
    margin-left: 80px;
    width: 806px;
    height: auto;
}
.contentText8{
    margin-left: 80px;
    height: auto;
    font-size: 20px;
    font-family: STFangsong;
    color: #3A3A3A;
    float:left;
    text-indent:0;
    font-weight: 600;
    margin-top: 20px;
    width: 370px;
    line-height: 35px;
}
.contentText9{
    margin-right: 80px;
    height: auto;
    font-size: 20px;
    font-family: STFangsong;
    color: #3A3A3A;
    float:right;
    text-indent:0;
    font-weight: 600;
    margin-top: 20px;
    width: 370px;
    line-height: 35px;
}

.table7Text1{
  width: 161px;
  padding: 10px;
  font-size: 20px;
font-family: STFangsong;
border-right:1px solid #000000 ;
color: #3A3A3A;
line-height: 25px;
text-align: center;
}
.confirmContract{
  position: absolute;
    top: 4350px;
    left: calc(50% - 100px);
    width: 200px;
height: 54px;
background: #FFFFFF;
border-radius: 8px;
border: 1px solid #1E81EB;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #1E81EB;
line-height: 54px;
text-align: center;
cursor: pointer;
}
.confirmContract11{
    position: absolute;
    top: 4440px;
    left: calc(50% - 100px);
    width: 200px;
height: 54px;
background: #1E81EB;
border-radius: 8px;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 54px;
text-align: center;
cursor: pointer;
}
.contractDialog{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.white1{
  position: absolute;
  top: calc(50% - 200px);
  left: calc(50% - 400px);
  width: 800px;
  height: 400px;
  background: #ffffff;
  border-radius: 12px;
}
.closeDialog{
position: absolute;
width: 25px;
height: 25px;
top: 5px;
right: 5px;
cursor: pointer;
}
.diglogText1{
  position: absolute;
  top: 50px;
  left: calc(50% - 400px);
  width:800px;
height: 25px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 25px;
text-align: center;
}
.diglogText2{
  position: absolute;
  top: 125px;
  left: calc(50% - 300px);
  width: 600px;
height: 60px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 30px;
text-align: center;
}
.diglogText3{
  position: absolute;
  top: 115px;
  left: 74px;
  width: 660px;
height: 120px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 30px;
text-align: left;
}
.dialog1Button1{
  position: absolute;
  top: 310px;
  left: 262px;
  width: 128px;
height: 40px;
border-radius: 6px;
border: 1px solid #336699;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #336699;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.dialog1Button2{
  position: absolute;
  top: 310px;
  left: 410px;
  width: 128px;
height: 40px;
border-radius: 6px;
background: #336699;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.contractPaper {
  position: absolute;
  top: 260px;
  left: calc(50% - 640px);
  width: 1280px;
height: 668px;
  background: #ffffff;
  border-radius: 12px;
}
.downloadContract{
  position: absolute;
  top: 458px;
  left: calc(50% - 64px);
  width: 128px;
height: 40px;
border-radius: 6px;
border: 1px solid #336699;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #336699;
line-height: 40px;
text-align: center;
cursor: pointer;
}
.paperText1{
  position: absolute;
  top: 538px;
  left: 727px;
  width: 600px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #979797;
line-height: 20px;
}
.fileUpload{
  position: absolute;
      top: 235px;
      left:336px;
      width: 130px;
     height:20px;
     background-color: pink;
     opacity: 0;
  cursor: pointer;
  box-sizing: border-box;
  padding: 13px;
  z-index: 1;
  cursor: pointer;
}
.paperIcon{
  position: absolute;
  top: 238px;
  left:339px;
  width: 14px;
  height: 14px;
  cursor: pointer;
  
}
.paperText{
  position: absolute;
  top: 235px;
  left: 363px;
  width:120px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #006699;
line-height: 20px;
}
.paperText2{
  position: absolute;
  top: 235px;
  left: calc(50% - 400px);
  width:800px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #006699;
line-height: 20px;
text-align: center;
}
.paperConfirm{
position: absolute;
top: 310px;
left: calc(50% - 64px);
width: 128px;
height: 40px;
background: #CCCCCC;
border-radius: 6px;
font-size: 14px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 40px;
text-align: center;
}
</style>